export default {
  LandingPage: {
    intro_sub: '三星电视包装盒通过二次利用，可对保护环境做出贡献。',
    title: '三星升级回收包装',
    sequence1_1: '快来和我们一起',
    sequence1_2:
      '通过将电视包装盒重新利用来减少对环境资源的浪费。请向下滑动开启你的第一步',
    sequence2_1: '三星升级回收包装（Samsung Upcycle-Packaging）',
    sequence2_2:
      '专为环境保护而设计的电视包装盒。快用您的电视包装盒制做各种家居用品吧！',
    sequence3_1: '沿着包装盒上的印刷点剪切',
    sequence3_2: '并组合成一个令人惊叹的物品',
    sequence4_1: '首先选择要挑战的项目',
    sequence4_2:
      '然后选择您的电视包装盒类型，最后选择要创建的设计。现在，开启您的创作之旅吧！',
    selectBox: '选择产品',
    moreActivity: '有关三星可持续发展活动的更多信息',
    OLED: 'OLED',
    QLED8K: 'QLED', //update
    UHD: 'UHD', //update
    FHD: 'FHD',
    HD: 'HD',
    theFrame: 'The Frame',
    theSerif: 'The Serif',
    theSero: 'The Sero',
    theTerrace: 'The Terrace', //update
    thePremiere: 'The Premiere', //update
    Monitors: 'Monitors', //update
    OdysseyArk:"Odyssey Ark",
    QSoundbar: 'Q Soundbar', //update
    Soundbar: 'Soundbar', //update
    SoundbarSet01:'Soundbar Set 1',
    SoundbarSet02:'Soundbar Set 2',
    TheTerraceSoundbar:'The Terrace Soundbar',
    Soundtower:'Sound Tower',
    BespokeJet: 'BESPOKE Jet\n (Jet)',
    BespokeJetStation:'BESPOKE Jet\n (Clean Station™)',
    BespokeJetNCleanStation : 'BESPOKE Jet&\nClean Station™',
    BespokeJetNCleanStation2 : 'BESPOKE Jet&Clean Station™',
    BespokeCube53:'BESPOKE Cube™ AIR\n(53㎡)',
    BespokeCube70:'BESPOKE Cube™ AIR\n(70㎡)',
    BespokeCube106:'BESPOKE Cube™ AIR\n(106㎡)',
    BespokeCube123:'BESPOKE Cube™ AIR\n(123㎡)',
    Qooker:'Qooker',
    BespokeSlim:'BESPOKE \nSlim',
    TheFreeStyle:"The Freestyle",
    BespokeSlimCleanStation:"BESPOKE Slim&Jet\n(Clean Station™)",
    JetCleanStation:"Jet&\nClean Station™",
    JetCleanStation2:"Jet&Clean Station™",
    BlueSky:"BlueSky \n5500",
    BlueSky3000:"BlueSky \n3000",
    BlueSky3100:"BlueSky \n3100",
    BlueSky5000:"BlueSky \n5000",
    BespokeJetbot:"BESPOKE\n Jet Bot",
    BespokeJetbot2:"BESPOKE Jet Bot",
    BespokeJetbotPlus:"BESPOKE\n Jet Bot+",
    BespokeJetbotPlus2:"BESPOKE Jet Bot+",
    BespokeJetbotAI:"BESPOKE\n Jet Bot AI",
    BespokeJetbotAI2:"BESPOKE Jet Bot AI",
    Canister01:"Canister \n01",
    Canister02:"Canister \n02",
    Jupiter:"Vacuum \nCleaner",
    ref_cube:"BESPOKE Cube",
    WaterPurifier:"Water Purifier",
    LATIN:"LATIN",
    LATIN10:"LATIN10",
    MIRROR:"MIRROR",
    MW5100J:"MW5100J",
    STENA:"STENA",
    // moreActivityLink: 'https://www.samsung.com/cn/sustainability/overview/',
    // moreActivityLink:'https://www.samsung.com/cn/aboutsamsung/sustainability/strategy/',
    moreActivityLink: 'https://www.samsung.com/cn/sustainability/overview/',
    footer: '© 2019-2021 三星（中国）投资有限公司 版权所有',
    // <br/>
    // 此网页最好使用IE9 浏览器、谷歌浏览器、苹果浏览器和其他新式浏览器进行浏览。<br/>
    // 京ICP备05068163号  京公网安备11010502040099号`
  },
  ProductPage: {
    selectDesign: '选择要创建的设计',
    selectDesignDezeen: 'Samsung X Dezeen', //update
    selectDesignSoccer: 'Samsung X Football', 
    tvConsole: '电视控制台',
    StorageBox: '储物盒',
    MagazineRack: '杂志架',
    CatHouse: '猫屋',
    CatTunnel: '猫隧道',
    BookShelf: '书架',
    DeskShelf: '置物架',
    BlackRhino: 'Endangered \n Animals \n Black Rhino', //update
    PolarBear: 'Endangered \n Animals \n Polar Bear', //update
    SeaTurtle: 'Endangered \n Animals \n Sea Turtle', //update
    TheRider: 'The Rider', //update
    Kibe: 'Kibe', //update
    Tessellate: 'Tessellate', //update
    Twist: 'Twist', //update
    AlexCouchArmTable: 'Alex Couch \n Arm Table', //update
    BlastOffClubHouse: 'Blast Off \n Club House', //update
    KinokoTable: 'Kinoko table', //update
    Magnuss: 'Magnuss', //update
    GIO: 'Gio', //update
    PostCardPlanter: 'Postcard \n Planter', //update
    SneakerRack: 'Sneaker \n Rack', //update
    TheSoban: 'The Soban', //update
    ToolBox: 'Tool Box', //update
    DeskStationary: '文具',
    CoinBank: '存钱罐',
    MobileScanner:'智能手机扫描仪支架',
    TabletScanner:'智能平板扫描仪支架',
    PetStairs:'宠物楼梯',
    PetFurniture: 'Pet Friendly Furniture',
    ShoeRackA:'Shoe Rack_A',
    ShoeRackB:'Shoe Rack_B',
    WineRackDog:'Wine Rack Dog',
    WineRack:'Wine Rack',
    mins: '分钟',
    all:'ALL',
    in: '英寸适用',
    inOnly: '英寸适用',
    allBoxSize: '所有尺寸',
    soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
  },
  DetailGuidePage: {
    1:'1',
    2:'2',
    3:'3',
    instructions: '说明',
    prepare: '准备电视盒',
    LetsDesign: '开始设计',
    drawParts: '在盒子上画部件',
    note1: '请注意，图形位置可能会因国家/地区和尺寸而异',
    note2: '先画出整个草图，使其适合电视盒',
    numberSpace: '数字=圆点间距',
    diagonal: '对角线',
    LEFT: '左',
    RIGHT: '右',
    TOP: '上',
    TOP1: '上 1',
    TOP2: '上 2',
    BACK: '后',
    MIDDLE: '中',
    MIDDLE2: '中 2',
    BOTTOM: '下',
    FRONT: '前',
    SIDE: '侧',
    secondSIDE: '第二面',
    secondSIDE1: '第二面 1',
    secondSIDE2: '第二面 2',
    LEG: '腿', //update
    JOINT: '接合处', //update
    FACE: '面部', //update
    DRAWERBOTTOM: '抽屉底部', //update
    DRAWERSIDE: '抽屉侧面', //update
    NOSE: '鼻', //update
    HANDLE: '手柄', //update
    BOTTOMSIDE: '底部', //update
    TOPSIDE: '顶部', //update
    WING: '侧翼', //update
    cutAndAssemble: '开始切割和组装',
    beCareful: '使用切割器时请小心不要受伤',
    cutOutParts: '切割出零件',
    assemble: '组装',
    Assemblyguide: '组装指南', //update
    fold: '折叠例子',
    foldGuide: '折叠硬纸板时请使用家具的边缘',
    foldGuideDezeen: '用压痕工具在纸板上压出几道虚线，以帮助纸板折叠', //update
    glue: '请在表面均匀涂抹胶水或胶带', //update
    cable: '请使用电缆扎带或绳索连接。', //update
    done: '完成！',
    goBack: '返回主菜单',
  },
  CautionPage: {
    CAUTION: '小心',
    needItem: '您需要这些物品',
    children: '儿童应在成人陪同下使用',
    mat: '请在地面铺上防护罩，以防刮伤地板',
    doNotPutHeavyThing: '不要踩踏或坐在这些家具上，并尽量避免放置重物在其上面',
    doNotThrow: '切勿将家具朝任何物体抛出或踢出，包括人和动物',
    stayAwayFlame: '远离火源',
    stayAwayWater: '切勿靠近水或潮湿环境',
    mayDamaged: '* 电视盒在运输途中可能会受损',
    companyDoestResponsible: '* 公司对运输途中造成的故障或人身伤害概不负责',
    cannotBeReturned:'',
    understand: '好的，我知道了',
  },
  PrivacyPolicy: {
    title: '隐私政策',
  },
  GoingGreen: {
    visual: {
      title: 'Going Green',
      text1: '我们正采用新的环保包装，从而加强我们对可持续发展的承诺。',
      text2:
        '我们减少了电视包装的纸张和油墨用量，而这些纸张和油墨可以变成生活用品。',
      text2_special:'',
      text3: '请选择下面的按钮来了解更多信息。',
    },
    greenIn: {
      title: '用电视机包装践行环保',
      subtitle1: '无墨产品信息',
      subtitle2: '再生利用生态包装',
      desc: '搜索型号名称了解更多信息',
      descM: '*Take a photo of the TV model number',
      guide: '型号名称',
      button: 'Take Photo',
      button2: '前往制作',
    },
    search: {
      guide: 'Search..',
      noResult: '无结果',
      more: '更多',
    },
  },
  searchCountrySelect: '选择要搜索的国家'
};
